import * as React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import Ann from "../img/annWatkins.jpg";
import pinkLotusBackground from "../img/pinkLotusBackground.jpeg";
import "./routes.css";

const contactHero = {
  backgroundImage: `url(${pinkLotusBackground})`,
};

function Contact() {
  return (
    <div className="contactHero" style={contactHero}>
      <div className="contactPanel">
        <h2 className="contactTitle">Contact</h2>
        <p className="contactLead">
          Visits are by appointment only. Call or email to schedule.
        </p>

        <div className="contactWho">
          <img src={Ann} className="contactPhoto" alt="Ann Watkins" />
          <div>
            <div className="contactName">Ann Watkins, MA</div>
            <div className="contactCred">
              Licensed Massage Therapist #000393
              <br />
              New Harmony Therapeutic Massage &amp; Somatic Bodywork
            </div>
          </div>
        </div>

        <ul className="contactList">
          <li>
            <FontAwesomeIcon icon={faPhone} />
            <a href="tel:8605994533">(860) 599-4533</a>
          </li>
          <li>
            <FontAwesomeIcon icon={faEnvelope} />
            <a href="mailto:bodymindspiritanatomy@gmail.com">
              bodymindspiritanatomy@gmail.com
            </a>
          </li>
          <li>
            <FontAwesomeIcon icon={faLocationDot} />
            <span>
              13 River Crest Drive
              <br />
              Pawcatuck, CT 06379
            </span>
          </li>
          <li>
            <FontAwesomeIcon icon={faClock} />
            <span>By appointment only</span>
          </li>
        </ul>

        <div className="contactNote">
          <strong>Before you visit:</strong> please be fragrance free, as some
          of our clients are exceptionally sensitive. Our entrance has seven
          low steps; let us know if you have special needs and we will do our
          best to accommodate you.{" "}
          <Link to="/greenStudio">About our studio ››</Link>
        </div>

        <div className="btnRow">
          <a href="tel:8605994533" className="omCta contactCta">
            Call Now
          </a>
          <a
            href="mailto:bodymindspiritanatomy@gmail.com"
            className="heroSecondaryBtn contactCtaAlt"
          >
            Send an Email
          </a>
        </div>

        <div className="heroSecondaryLabel">Looking for something else?</div>
        <div className="btnRow">
          <Link to="/classes" className="heroSecondaryBtn contactLink">
            Classes
          </Link>
          <Link to="/store" className="heroSecondaryBtn contactLink">
            Gift Certificates
          </Link>
          <Link to="/faq" className="heroSecondaryBtn contactLink">
            FAQ
          </Link>
        </div>
      </div>
    </div>
  );
}
export default Contact;
